import { Injectable, Inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { switchMap, map, withLatestFrom, catchError } from 'rxjs/operators';
import { IAppState } from '../state/app.state';
// tslint:disable-next-line:max-line-length
import { EUserActions, LoginUser, LoginUserSuccess, LoginUserError,
    SendLinkForForgotPswd, SendLinkForForgotPswdSuccess, SendLinkForForgotPswdError,
     ResetPassword, ResetPasswordSuccess, ResetPasswordError,
      UpdateTerms,
      UpdateTermsSucces,
      UpdateTermsError,
      CheckPswdLink,
      CheckPswdLinkSuccess,
      CheckPswdLinkError,
      ResetPasswordByLinkSuccess,
      ResetPasswordByLinkError,
      ResetPasswordByLink} from '../actions/user.actions';
// import { LoginUserHttp } from '../../models/http-models/user-http.interface';
import { UserService } from '../../Services/User/user.service';
// import { selectUserList } from '../selectors/user.selector';
import { User } from '../../Models/User';
// tslint:disable-next-line:import-blacklist
import { Observable, of } from 'rxjs';
// import { JwtService } from '../../services/jwt.service';
// tslint:disable-next-line:import-blacklist


@Injectable()
export class UserEffects {

    loginUsers$ = createEffect(() => this.actions$.pipe(
        ofType<LoginUser>(EUserActions.LoginUser),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.userService.adminLogin(payload).pipe(
                map((userDetails: User) => {
                    this.userService.setUserdetails(userDetails);
                    return new LoginUserSuccess(userDetails);
                }),
                catchError((err) => of(new LoginUserError(err)))
            );
        })));


           UpdateTerms$ = createEffect(() => this.actions$.pipe(
               ofType<UpdateTerms>(EUserActions.UpdateTerms),
               map(action => action.payload),
               switchMap((payload:any) => {
                   return this.userService.updateTerms(payload).pipe(
                       map((userDetails: User) => {
                        //    this.userService.setUserdetails(userDetails);
                           return new UpdateTermsSucces(userDetails);
                        }),
                        catchError((err) => of(new UpdateTermsError(err)))
                    );
                })
           ));


    sendPasswordResetLink$ = createEffect(() => this.actions$.pipe(
        ofType<SendLinkForForgotPswd>(EUserActions.SendLinkForForgotPswd),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.userService.forgotPswdCheckUsername(payload).pipe(
                map((result: any) => {
                    return new SendLinkForForgotPswdSuccess(result);
                }),
                catchError((err) => of(new SendLinkForForgotPswdError(err)))
            );
        })));


    resetPassword$ = createEffect(() => this.actions$.pipe(
        ofType<ResetPassword>(EUserActions.ResetPassword),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.userService.resetPassword(payload).pipe(
                map((result: any) => {
                    return new ResetPasswordSuccess(result);
                }),
                catchError((err) => of(new ResetPasswordError(err)))
            );
        })));


    checkPswdLink$ = createEffect(() => this.actions$.pipe(
        ofType<CheckPswdLink>(EUserActions.CheckPswdLink),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.userService.checkPswdLink(payload).pipe(
                map((result: any) => {
                    return new CheckPswdLinkSuccess(result);
                }),
                catchError((err) => of(new CheckPswdLinkError(err)))
            );
        })));

    resetPswdByLink$ = createEffect(() => this.actions$.pipe(
        ofType<ResetPasswordByLink>(EUserActions.ResetPasswordByLink),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.userService.resetPswdByLink(payload).pipe(
                map((result: any) => {
                    return new ResetPasswordByLinkSuccess(result);
                }),
                catchError((err) => of(new ResetPasswordByLinkError(err)))
            );
        })));


    constructor(
        private userService: UserService,
        private actions$: Actions,
        private store: Store<IAppState>,
        // private jwtService: JwtService
    ) { }

}
